import React from 'react';
import { NavLink } from 'react-router-dom';
import { Table, Users, UsersThree, GridFour, GearSix, BookOpen } from '@phosphor-icons/react';
import { useLayout } from '../../contexts/LayoutContext';
import { useRoles } from '../../hooks/useRoles';

const AdminSection = () => {
  const { navCollapsed } = useLayout();
  const {
    hasAdminAccess,
    isSuperAdmin,
    isAdmin,
    isContentManager,
    isSuperContentManager,
    isCoach
  } = useRoles();

  if (!hasAdminAccess()) {
    return null;
  }

  const iconSize = navCollapsed ? 18 : 15;

  const canSeeUserManagement = isSuperAdmin() || isAdmin();
  const canSeeOrgManagement = isSuperAdmin() || isAdmin();
  const canSeeTenantManagement = isSuperAdmin();
  const canSeeContentManagement = isSuperAdmin() || isSuperContentManager();
  const canSeeReporting = isSuperAdmin() || isAdmin() || isSuperContentManager() || isContentManager() || isCoach();

  return (
    <div className="admin-section">
      {!navCollapsed && (
        <span className="admin-section-label">Admin</span>
      )}

      {canSeeReporting && (
        <NavLink
          to="/app/reports"
          className={({ isActive }) => `admin-item ${isActive ? 'active' : ''}`}
          title="Reporting"
        >
          <span className="nav-icon"><Table weight="light" size={iconSize} /></span>
          {!navCollapsed && <span className="nav-label">Reporting</span>}
        </NavLink>
      )}

      {canSeeUserManagement && (
        <NavLink
          to="/app/users"
          className={({ isActive }) => `admin-item ${isActive ? 'active' : ''}`}
          title="User Management"
        >
          <span className="nav-icon"><Users weight="light" size={iconSize} /></span>
          {!navCollapsed && <span className="nav-label">User Management</span>}
        </NavLink>
      )}

      {canSeeOrgManagement && (
        <NavLink
          to="/app/org"
          className={({ isActive }) => `admin-item ${isActive ? 'active' : ''}`}
          title="Org Management"
        >
          <span className="nav-icon"><UsersThree weight="light" size={iconSize} /></span>
          {!navCollapsed && <span className="nav-label">Org Management</span>}
        </NavLink>
      )}

      {canSeeTenantManagement && (
        <NavLink
          to="/app/tenants"
          className={({ isActive }) => `admin-item ${isActive ? 'active' : ''}`}
          title="Tenant Management"
        >
          <span className="nav-icon"><GridFour weight="light" size={iconSize} /></span>
          {!navCollapsed && <span className="nav-label">Tenant Management</span>}
        </NavLink>
      )}

      {canSeeTenantManagement && (
        <NavLink
          to="/app/system"
          className={({ isActive }) => `admin-item ${isActive ? 'active' : ''}`}
          title="System Management"
        >
          <span className="nav-icon"><GearSix weight="light" size={iconSize} /></span>
          {!navCollapsed && <span className="nav-label">System Management</span>}
        </NavLink>
      )}

      {canSeeContentManagement && (
        <NavLink
          to="/app/content"
          className={({ isActive }) => `admin-item ${isActive ? 'active' : ''}`}
          title="Methodology Management"
        >
          <span className="nav-icon"><BookOpen weight="light" size={iconSize} /></span>
          {!navCollapsed && <span className="nav-label">Methodology Management</span>}
        </NavLink>
      )}

      <hr className="admin-section-divider" />
    </div>
  );
};

export default AdminSection;
